import EditPostDocPage from './EditPostDocPage';
export default EditPostDocPage;
